import {
  createFrontendModule,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { PageErrorBoundary } from '@vivicta/ui';
import { Wrench } from 'lucide-react';

/**
 * Replaces `page:devtools` from `@backstage/plugin-devtools` with a
 * Tailwind/shadcn page (ADR-0012). The stock page is a Material-UI shell whose
 * tabs are contributed by `SubPageBlueprint` extensions; overriding the page
 * drops those inputs, which is intentional — the only external contributor was
 * the Unprocessed Entities sub-page, and that now has its own Admin page.
 *
 * `title` and `icon` are repeated because `PageBlueprint` only emits
 * `core.title` / `core.icon` when the params carry them, and the sidebar's
 * Admin section takes its nav item by page id.
 */
export const devToolsModule = createFrontendModule({
  pluginId: 'devtools',
  extensions: [
    PageBlueprint.make({
      params: {
        path: '/devtools',
        title: 'DevTools',
        icon: <Wrench aria-hidden="true" className="size-4" />,
        noHeader: true,
        routeRef: createRouteRef({ aliasFor: 'devtools.root' }),
        loader: () =>
          import('./VivictaDevToolsPage').then(m => (
            <PageErrorBoundary title="DevTools">
              <m.VivictaDevToolsPage />
            </PageErrorBoundary>
          )),
      },
    }),
  ],
});
